import { render, staticRenderFns } from "./configMsg.vue?vue&type=template&id=47382052&scoped=true&"
import script from "./configMsg.vue?vue&type=script&lang=ts&"
export * from "./configMsg.vue?vue&type=script&lang=ts&"
import style0 from "./configMsg.vue?vue&type=style&index=0&id=47382052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47382052",
  null
  
)

export default component.exports